export default function SourceAttribution({ source }) {
  if (!source?.reuse_license) return null;
  return <div className="mt-2 text-xs leading-5 text-slate-600" data-testid={`source-attribution-${source.source_id}`}>
    <p>{source.attribution}</p>
    <p>{source.license_url
      ? <a href={source.license_url} target="_blank" rel="noopener noreferrer" className="underline">{source.reuse_license}</a>
      : source.reuse_license}</p>
    {source.reuse_note && <p>{source.reuse_note}</p>}
  </div>;
}
